import { render, staticRenderFns } from "./personal-center.vue?vue&type=template&id=54ac468e&scoped=true&"
import script from "./personal-center.vue?vue&type=script&lang=js&"
export * from "./personal-center.vue?vue&type=script&lang=js&"
import style0 from "./personal-center.vue?vue&type=style&index=0&id=54ac468e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac468e",
  null
  
)

export default component.exports